import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Box)(() => ({
  width: "100%",
})) as typeof Box;
